import { CacheKeysModel } from 'utils/types/CacheKeyModel';

export const CacheKeys: CacheKeysModel = {
  isAuthenticated: 'persist:isAuthenticated',
  kickcallAgency: 'kickcall-agency',
  themeColor: 'persist:theme-color',
  businessIds: 'persist:business-ids',
  locationIds: 'persist:location-ids',
  agentIds: 'persist:agent-ids',
  selectedAgentId: 'persist:selected-agent-id',
  userEmail: 'user-email',
  userStatus: 'user-status',
  authToken: 'auth-token',
  ssoSupportToken: 'sso-support-token',
  accountStatus: 'account_status',
  onboardingFormProgress: 'onboarding-form-progress'
};
